const locale = {
  appName: 'Kiness',
  tagline: 'Manteniendo a las familias conectadas',
  signIn: 'Iniciar sesión',
  signUp: 'Registrarse',
  signOut: 'Cerrar sesión',
  email: 'Correo electrónico',
  password: 'Contraseña',
  name: 'Nombre completo',
  facilityCode: 'Código del centro',
  facilityCodeHint: 'Pídale este código a su residencia',
  noAccount: '¿No tiene una cuenta?',
  haveAccount: '¿Ya tiene una cuenta?',
  signingIn: 'Iniciando sesión…',
  creatingAccount: 'Creando cuenta…',
  loginError: 'No se pudo iniciar sesión — revise su correo y contraseña',
  registerError: 'No se pudo crear la cuenta — intente de nuevo',
  welcomeBack: 'Bienvenido de nuevo',
  welcomeNew: 'Únase a su comunidad de cuidado',
  selectResident: '¿Para quién es esta actualización?',
  updatePlaceholder: '¿Cómo está {name} hoy?',
  addPhoto: 'Agregar foto',
  postUpdate: 'Publicar actualización',
  posting: 'Publicando…',
  postSuccess: 'Actualización publicada — la familia será notificada',
  postError: 'No se pudo publicar — revise su conexión e intente de nuevo',
  yourLovedOne: 'Su ser querido',
  familyFeed: 'Noticias de la familia',
  tabFeed: 'Feed',
  tabRecord: 'Registro',
  tabCalendar: 'Calendario',
  tabPhotos: 'Fotos',
  noUpdates: 'Aún no hay actualizaciones — vuelva pronto',
  pullRefresh: 'Deslice hacia abajo para actualizar',
  refreshing: 'Actualizando…',
  admin: 'Administración',
  dashboard: 'Panel',
  residents: 'Residentes',
  familyLinks: 'Vínculos familiares',
  staff: 'Personal',
  facility: 'Centro',
  residentsCount: 'Residentes',
  familyLinked: 'Familiares vinculados',
  updatesToday: 'Actualizaciones hoy',
  addResident: 'Agregar residente',
  editResident: 'Editar',
  removeResident: 'Eliminar',
  firstName: 'Nombre',
  lastName: 'Apellido',
  room: 'Habitación',
  save: 'Guardar',
  cancel: 'Cancelar',
  addFamilyEmail: 'Agregar familiar por correo',
  addStaffEmail: 'Agregar personal por correo',
  staffAdd: 'Agregar',
  staffCount: '{count} en el personal',
  relationship: 'Parentesco',
  inviteSent: 'Invitación lista — pueden registrarse con el código del centro',
  loading: 'Cargando…',
  installTitle: 'Agregar Kiness a su pantalla de inicio',
  installBody: 'Acceda rápido a las novedades de su ser querido',
  installButton: 'Agregar a pantalla de inicio',
  installDismiss: 'Ahora no',
  language: 'Idioma',
  chooseLanguage: 'Elija su idioma',
  chooseLanguageSub: '选择您的语言',
  changeLanguageHint: 'Puede cambiarlo cuando quiera con el ícono del globo',
  english: 'English',
  chinese: '中文',
  newUpdate: 'Nueva actualización',
  from: 'de',
  roomLabel: 'Habitación',
  confirmRemove: '¿Eliminar a este residente?',
  staffPostTitle: 'Publicar una actualización',
  adminTitle: 'Panel del centro',
  linkedFamily: 'Familia vinculada',
  pendingInvite: 'Invitación pendiente',
  noResidents: 'Aún no hay residentes — agregue el primero',
  noStaff: 'Aún no hay personal',
  photoOptional: 'Foto (opcional)',
  dashboardSettingUp: 'Preparando su panel…',
  dashboardEmptyHint: 'Agregue su primer residente para comenzar',
};

export default locale;
